<template>
  <v-app-bar 
    app 
    color="#173862" 
    absolute
    elevate-on-scroll
    dark
    height="50px"
  >
    <v-row align="center" justify="center">
      <!-- <v-col :cols="!$vuetify.breakpoint.mobile ? 2 : 3" align-self="center"> -->
      <v-col :cols="!$vuetify.breakpoint.mobile ? 2 : 3">
        <!-- <LocaleSelector v-if="!isUserAdmin"/> -->
        <!-- <LocaleSelector
          v-if="$route.name === 'login' || $route.name === 'registration' || $route.name === 'forgetPassword' || $route.name === 'resetPassword'"
        /> -->
        <a target="_blank" href="https://navomi.com/" rel="noopener">
          <v-img
            alt="Navomi Logo"
            class="shrink mr-2"
            contain
            :src="require('../assets/navomi_logo_alpha.png')"
            transition="scale-transition"
            width="200"
          />
        </a>
      </v-col>
      <v-col cols="1" v-if="!$vuetify.breakpoint.mobile"></v-col>
      <v-col :cols="!$vuetify.breakpoint.mobile ? 6 : 5"><h2 class="grey--text">CRM Connect</h2></v-col>
      <v-col cols="1" v-if="!$vuetify.breakpoint.mobile">
        <!-- <v-app-bar-nav-icon v-if="loggedIn" @click="drawer = true"></v-app-bar-nav-icon> -->
      </v-col>
      <v-col 
        :cols="!$vuetify.breakpoint.mobile ? 2 : 4"
        class="d-flex justify-end"
        :class="{ 'pl-0': $vuetify.breakpoint.mobile, 'pl-12': !$vuetify.breakpoint.mobile }" 
      >
        <!-- <a target="_blank" href="https://navomi.com/" rel="noopener">
          <v-img
            alt="Navomi Logo"
            class="shrink mr-2"
            contain
            :src="require('../assets/navomi_logo_alpha.png')"
            transition="scale-transition"
            width="200"
          />
        </a> -->
        <LocaleSelector
          v-if="$route.name === 'login' || $route.name === 'registration' || $route.name === 'forgetPassword' || $route.name === 'resetPassword' || $route.name === 'features'"
        />

        <v-tooltip 
           v-if="$route.name === 'login' || $route.name === 'registration' || $route.name === 'forgetPassword' || $route.name === 'resetPassword'"
          open-delay="300" 
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              @click="$router.push('/integration-features')"
              class="ml-2"
              color="grey"
              top
            >
              mdi-information-outline
            </v-icon>
          </template>
          <span>Integration Features</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
  // import { authComputed } from '@/store/helpers.js'

  export default {
    components: {
      LocaleSelector: () => import('@/components/LocaleSelector'), 
    },
    // created() {
    //   const isUserAdmin = this.isUserAdmin;
    // },
    // computed: {
    //   ...authComputed
    // }
  }
</script>

<style>

</style>
